export const focusAreas = [
  {
    id: 1,
    title: 'Health & Wellbeing',
    icon: 'health',
    shortDescription: 'Strengthening health systems and improving health outcomes for vulnerable populations.',
    description: 'InSocia works to strengthen health systems and improve health outcomes for vulnerable populations through universal health coverage policy research, maternal and child health program evaluations, community health worker effectiveness studies, health financing and equity analyses, healthcare access interventions for marginalized communities, and mental health policy development.',
    keyInitiatives: [
      'Universal Health Coverage Policy Research',
      'Maternal and Child Health Program Evaluations',
      'Community Health Worker Effectiveness Studies',
      'Health Financing and Equity Analyses',
      'Healthcare Access Interventions for Marginalized Communities',
      'Mental Health Policy Development'
    ],
    image: 'health-and-wellbeing.webp'
  },
  {
    id: 2,
    title: 'Education & Skills Development',
    icon: 'education',
    shortDescription: 'Improving educational access, quality, and outcomes through evidence-based approaches.',
    description: 'We focus on improving educational access, quality, and outcomes through education policy reform support, school effectiveness evaluations, teacher training program development, EdTech implementation research, skills development for youth employment, and education equity assessments.',
    keyInitiatives: [
      'Education Policy Reform Support',
      'School Effectiveness Evaluations',
      'Teacher Training Program Development',
      'EdTech Implementation Research',
      'Skills Development for Youth Employment',
      'Education Equity Assessments'
    ],
    image: 'education-and-skills-development.webp'
  },
  {
    id: 3,
    title: 'Sustainable Livelihoods',
    icon: 'livelihoods',
    shortDescription: 'Promoting economic opportunities that are inclusive and sustainable for communities.',
    description: 'Our work promotes economic opportunities that are inclusive and sustainable through financial inclusion program design, entrepreneurship support systems, value chain development and analysis, labor market interventions, social protection mechanism evaluations, and cooperative and community enterprise models.',
    keyInitiatives: [
      'Financial Inclusion Program Design',
      'Entrepreneurship Support Systems',
      'Value Chain Development and Analysis',
      'Labor Market Interventions',
      'Social Protection Mechanism Evaluations',
      'Cooperative and Community Enterprise Models'
    ],
    image: 'sustainable-livelihoods.webp'
  },
  {
    id: 4,
    title: 'Gender Equality & Inclusion',
    icon: 'gender',
    shortDescription: 'Advancing gender-responsive policies and programs for equitable development.',
    description: 'InSocia advances gender-responsive policies and programs through gender-based policy analysis, women\'s economic empowerment research, gender-responsive budgeting support, prevention of gender-based violence, women\'s leadership program development, and inclusive policy design for marginalized groups.',
    keyInitiatives: [
      'Gender-Based Policy Analysis',
      'Women\'s Economic Empowerment Research',
      'Gender-Responsive Budgeting Support',
      'Prevention of Gender-Based Violence',
      'Women\'s Leadership Program Development',
      'Inclusive Policy Design for Marginalized Groups'
    ],
    image: 'gender-equality-and-inclusion.webp'
  },
  {
    id: 5,
    title: 'Environmental Sustainability',
    icon: 'environment',
    shortDescription: 'Integrating environmental considerations into social policy for sustainable development.',
    description: 'We integrate environmental considerations into social policy through climate adaptation policy research, renewable energy access programs, sustainable agriculture promotion, water resource management, environmental justice initiatives, and ecosystem services valuation.',
    keyInitiatives: [
      'Climate Adaptation Policy Research',
      'Renewable Energy Access Programs',
      'Sustainable Agriculture Promotion',
      'Water Resource Management',
      'Environmental Justice Initiatives',
      'Ecosystem Services Valuation'
    ],
    image: 'environmental-sustainability.webp'
  },
  {
    id: 6,
    title: 'Rural Development & Agriculture',
    icon: 'rural',
    shortDescription: 'Strengthening rural communities and agricultural systems for sustainable growth.',
    description: 'Our rural development focus strengthens communities and agricultural systems through smallholder farmer support programs, agricultural technology adoption research, rural infrastructure development, market linkage facilitation, cooperative farming promotion, and rural-urban migration studies.',
    keyInitiatives: [
      'Smallholder Farmer Support Programs',
      'Agricultural Technology Adoption Research',
      'Rural Infrastructure Development',
      'Market Linkage Facilitation',
      'Cooperative Farming Promotion',
      'Rural-Urban Migration Studies'
    ],
    image: 'rural-development-and-agriculture.webp'
  }
]; 